import type { LibraryPreset } from './types';

/**
 * Pickable starter templates shown in the "Library" section of the pin editor.
 *
 * Selecting a preset pre-fills the editor form — it is NOT a pin until the
 * user saves. Values mirror the design bundle
 * (`/tmp/design-bundle/focused-view/project/data.jsx`, `libraryPresets`).
 */
export const LIBRARY_PRESETS: ReadonlyArray<LibraryPreset> = [
	{
		label: 'Objection Handler',
		keyword: 'objection',
		color: '#EC4899',
		prompt:
			'The prospect just raised an objection. Give me 2 rebuttal paths — one empathetic, one data-driven — and the question I should ask to keep them talking.',
	},
	{
		label: 'Discovery Questions',
		keyword: 'discovery',
		color: '#10A37F',
		prompt:
			"Generate 5 discovery questions tailored to this account's industry, role, and stage. Order them from lowest-stakes to highest-stakes.",
	},
	{
		label: 'Pricing Talk Track',
		keyword: 'pricing',
		color: '#64748B',
		prompt:
			"Lay out a pricing talk track: anchor value first, then pricing structure, then what to do if they flinch. Include the 2 concessions I can offer and the 2 I can't.",
	},
	{
		label: 'Next Steps',
		keyword: 'next steps',
		color: '#3B82F6',
		prompt:
			"Based on what we've covered, propose specific next steps with dates. Include who owns each and why each one matters for the deal.",
	},
	{
		label: 'Pain Points',
		keyword: 'pain',
		color: '#EA6A2C',
		prompt:
			"Summarize the prospect's pain points in their own words. Rank by urgency and tie each to a specific capability we offer.",
	},
];
